import React, {useRef} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/bundle';
import 'swiper/css/navigation';
import {  Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper/modules';
import '../styles/gallery.scss';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate



function Gallery() {
  const navigate = useNavigate(); // Inizializza useNavigate
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };
    const slides = [
        { image: '/images/MFW2024/MaddalenaAnteprima.jpg', title: "Maddalena Svevi x Anteprima Fashion Show", description: "" },
        { image: '/images/MFW2024/MeganRiaAnteprima.jpg', title: "Megan Ria x Anteprima Fashion Show", description: "" },
        { image: '/images/MFW2024/MeganRiaPloom.jpg', title: "Megan Ria x Ploom Event", description: "" },
        { image: '/images/MFW2024/MeganRiaFiorucci.jpg', title: "Megan Ria x Fiorucci Event", description: "" },
        { image: '/images/MFW2024/MeganRiaSaraWong.jpg', title: "Megan Ria x Sara Wong Fashion Show", description: "" },
        { image: '/images/MFW2024/MaddalenaSaraWong.jpg', title: "Maddalena Svevi x Sara Wong Fashion Show", description: "" },
        { image: '/images/MFW2024/MaddalenaRichmond.jpg', title: "Maddalena Svevi x Richmond Event", description: "" },
        { image: '/images/MFW2024/MeganPhilipp.jpg', title: "Megan Ria x Philippe Plein Fashion Show", description: "" },
        { image: '/images/MFW2024/MeganFranchi.jpg', title: "Megan Ria x Elisabetta Franchi Fashion Show", description: "" },
        { image: '/images/MFW2024/MeganRichmond.jpg', title: "Megan Ria x Richmond Event", description: "" },
        { image: '/images/MFW2024/MeganANIYE.jpg', title: "Megan Ria x ANIYE Fashion Show", description: "" },
        { image: '/images/MFW2024/MeganAvavav.jpg', title: "Megan Ria x AVAVAV Fashion Show", description: "" },
        { image: '/images/MFW2024/MaddalenaPloom.jpg', title: "Maddalena Svevi x Ploom Event", description: "" },
    ];
   return (
    <div id="my-swiper">
      
      <Swiper
        slidesPerView="auto"
        spaceBetween={40}
        centeredSlides={true}
        grabCursor={true}
        loop={true}
        modules={[Navigation, Pagination, EffectCoverflow,Autoplay]}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        effect="coverflow"
        coverflowEffect={{
          rotate: 10,
          stretch: 0,
          depth: 100,
          modifier: 1.2,
          slideShadows: false,
        }}
        pagination={{ clickable: true }}
        navigation={false} /* Disabilito i button*/
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        breakpoints={{
          300: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1850: {
            slidesPerView: 4.5,
            spaceBetween: 25,
          },
          1920: {
            slidesPerView: 4,
            spaceBetween: 100,

          }
        }}
      > 
      {slides.map((slide, index) => (
        <SwiperSlide key={index} className="swiper-slide" onClick={() => navigate('/mfwfebruary')}>
          <div className="swiper-slide-content">
            <img src={slide.image} alt={slide.title} className="swiper-slide-image"/>
            <div className="swiper-slide-textbox">
              <p className="swiper-text-large">{slide.title}</p>
              <p className="swiper-text-small">{slide.description}</p>
            </div>
          </div>
        </SwiperSlide>
      ))}
      <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
    </Swiper>
  </div>
);
};

export default Gallery;